import { ButtonLink } from '@designsforhealth/dfh-react-components'
import React from 'react'
import styled from 'styled-components'

import { CartItem } from '../../lib/cart/types'
import { cartItemDisplayName } from '../../utils/itemTools'
import RenderCleanHtml from '../RenderCleanHtml'

import closeModalIcon from '../../img/close_modal.svg'

const StyledTitle = styled.header`
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  margin-bottom: 20px;
  h4 {
    padding: 30px 0 0 30px;
    // normalize styles in global and buy environments
    margin-top: 0;
    margin-bottom: 0;
  }
  ${ButtonLink} {
    // provide a slightly larger touchpoint
    flex: 0 0 44px;
    height: 44px;
    margin-right: 15px;
    margin-top: 15px;
    padding: 15px;
  }
`

const StyledRenderCleanHtml = styled(RenderCleanHtml)`
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0 30px;
  p,
  ul,
  ol {
    // normalize styles in global and buy environments
    margin: 0 0 1.2em;
    &:last-child {
      margin-bottom: 0;
    }
  }
  ul,
  ol {
    padding-left: 2em;
  }
  li {
    margin-bottom: 0.3em;
  }
`

export interface CartItemDescriptionModalProps {
  className?: string
  description: string
  handleClose(): void
  item: CartItem
}

const CartItemDescriptionModalContents: React.FC<CartItemDescriptionModalProps> = ({
  className,
  description,
  handleClose,
  item,
}) => (
  <div className={className}>
    <StyledTitle>
      <h4>{cartItemDisplayName({ item })}</h4>
      <ButtonLink onClick={handleClose} underline={false}>
        <img alt="Close item description modal" src={closeModalIcon} />
      </ButtonLink>
    </StyledTitle>

    <StyledRenderCleanHtml htmlString={description} />
  </div>
)

export default CartItemDescriptionModalContents
